import { createVNode, render } from "vue"
import LoadingComponent from "./Loading.vue"

let globalLoadingInstance = null
let requestCount = 0
let loadingContainer = null

function removeLoading(container) {
  render(null, container)
  if (document.body.contains(container)) {
    document.body.removeChild(container)
  }
  if (loadingContainer === container) {
    loadingContainer = null
    globalLoadingInstance = null
  }
}

function createLoading() {
  const container = document.createElement("div")
  document.body.appendChild(container)
  loadingContainer = container

  const vnode = createVNode(LoadingComponent, {
    onDestroy: () => {
      removeLoading(container)
    },
  })

  render(vnode, container)

  const instance = vnode.component?.proxy

  return {
    show: () => instance?.show(),
    hide: () => instance?.hide(),
    destroy: () => {
      instance?.hide()
      setTimeout(() => {
        removeLoading(container)
      }, 300)
    },
  }
}

function getOrCreateLoading() {
  if (!globalLoadingInstance) {
    globalLoadingInstance = createLoading()
  }
  return globalLoadingInstance
}

function Loading() {
  const instance = getOrCreateLoading()

  requestCount += 1
  instance.show()
  return instance
}

Loading.show = () => Loading()

Loading.hide = () => {
  requestCount -= 1
  if (requestCount <= 0) {
    requestCount = 0
    globalLoadingInstance?.hide()
  }
}

Loading.forceHide = () => {
  requestCount = 0
  globalLoadingInstance?.hide()
}

Loading.getCount = () => requestCount

Loading.destroy = () => {
  globalLoadingInstance?.destroy()
  requestCount = 0
}

export default Loading
